import React, { useRef, useState, useEffect } from 'react';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITEKEY;

const RecaptchaComponent = ({setIsVerifyCode, setCaptchaToken, action, light}) => {
  const recaptchaRef = useRef(null);
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/enterprise.js?render=explicit';
    script.async = true;
    script.defer = true;
    script.onload = () => setIsScriptLoaded(true);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (isScriptLoaded && recaptchaRef.current) {
      window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise.render(recaptchaRef.current, {
          'sitekey': RECAPTCHA_SITE_KEY,
          'theme': light? "light" : "dark",
          'action': action,
          // 'size':  'compact',
          'callback': (token) => {
            // localStorage.setItem("recapToken", token)
            setIsVerifyCode(true)
            setCaptchaToken(token)
          },
          'expired-callback': () => {
            setIsVerifyCode(false)
            setCaptchaToken("")
          }
        });
      });
    }
  }, [isScriptLoaded]);

  return <div ref={recaptchaRef}></div>;
};

export default RecaptchaComponent;